import { render } from "./ObjectsListView.vue?vue&type=template&id=3f0febe8"
import script from "./ObjectsListView.vue?vue&type=script&lang=js"
export * from "./ObjectsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__